import { FC, JSX } from 'react';

import { Skeleton } from '@mui/joy';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';

const SidebarMenuLoader: FC = (): JSX.Element => {
  return (
    <>
      {[...Array(6)].map((_, index) => (
        <ListItem key={index}>
          <ListItemButton disabled>
            <Skeleton height={24} sx={{ width: '95%', borderRadius: '3px' }} />
          </ListItemButton>
        </ListItem>
      ))}
    </>
  );
};

export default SidebarMenuLoader;
